module.exports = __webpack_public_path__ + "43445e025eb2e1898fc8d20d2b2da059.pdf";